export const FrequencyChartViewVariants = [
  {
    label: 'Bar chart',
    value: 'bar',
  },
  {
    label: 'Cumulative Bar chart',
    value: 'cumulative',
  },
];
